const ToolsList = ({
  links,
  url,
  sendClickMenuTools,
}: {
  links: { title: string; text: string; href: string; event: string }[];
  url: string;
  sendClickMenuTools: Function;
}): JSX.Element => {
  if (!links) return <></>;

  const linksView = links
    .filter((link) => link.href !== url)
    .map((link, index) => {
      return (
        <li
          key={index}
          className="footer__tools-list-item"
          onClick={() => sendClickMenuTools(link.event)}
        >
          <a title={link.title} href={link.href}>
            {link.text}
          </a>
        </li>
      );
    });

  return <>{linksView}</>;
};

export default ToolsList;
